import { Document2Post } from './document.type';
import { AmType } from './types.type';
import { UnderwriterReview } from './underwriting.type';
import { Organization } from './organization.type';
import { Quote } from 'types/quote.type';
import { FinancialTransaction } from './financial.types';
import { Referral } from './referrals.type';
import { Location } from 'types/location.type';
import PolicyLocation from '../application/Models/PolicyLocation';

export interface Loss {
    id?: string;
    locationId: string;
    date: string;
    description: string;
    perilType: string;
    status: string;
    reserved: string;
    paid: string;
}

export interface SubmissionDetails {
    id: string;
    actionType?: AmType;
    actionTypeId?: string;
    address1: string;
    address2: string;
    agencyName?: string;
    agentName?: string;
    producer: Organization;
    averageRents?: string;
    city: string;
    documents: Document2Post[];
    boundDocuments: Document2Post[];
    lossDocuments: Map<string, Document2Post[]>;
    effectiveDate: string;
    expirationDate?: string;
    endorsementTypeId?: string;
    endorsementType?: AmType;
    endorsementNumber?: string;
    endorsingSubmissionId: string;
    insuranceToValue?: string;
    isEndorsement: boolean;
    isRemovalEndorsement: boolean;
    locations: Location[];
    losses: Loss[];
    maxTivPerBuilding?: string;
    namedInsured: string;
    narrative: string;
    statusTypeId: string;
    statusType: AmType;
    state: string;
    totalInsurableValue?: string;
    underwriterReviews?: UnderwriterReview[];
    transactionEntries: FinancialTransaction[];
    quotes?: Quote[];
    zip: string;
    endorsements?: SubmissionDetails[];
    renewingSubmission?: SubmissionDetails;
    isInForce: boolean;
    isBound: boolean;
    isExpiring: boolean;
    isExpired: boolean;
    isPolicy: boolean;
    isRenewal: boolean;
    effectivePolicyNumber: string;
    hasAgentMessages: boolean;
    hasLumenMessages: boolean;
    numLocations?: number;
    maxLocationTiv?: number;
    uwStatus: SubmissionUnderwritingStatus;
    inspectionData: SubmissionInspectionData;
    underwritingNotes: string;
    primaryLimit?: string;
    hasOpenReferredLocations?: boolean;
    hasAllApprovedReferredLocations: boolean;
    referrals?: Referral[];
    isReferralTriggered?: boolean;
    policies?: Policy[];
    endorsingPolicy?: Policy;
    pqScore?: string;
    description: string;
    submissionProductDetails?: SubmissionProductDetails[];
    intendedProductLineCodes?: string[];
}

export interface SubmissionProductDetails {
    productLineCode: string;
}

export interface SubmissionBrDetails extends SubmissionProductDetails {
    followedPolicyInsurer: string;
    followedPolicyNumber: string;
    followedPolicyCoverageForm: string;
}

export interface Policy {
    id: string;
    policyNumber: string;
    productLineType: string;
    effectiveDate: string;
    expirationDate: string;
    documents: Document2Post[];
    isInForce: boolean;
    effectivePolicyLocations: PolicyLocation[];
    totalBoundPremium: number;
    totalEarnedPremium: number;
    isRenewal: boolean;
    renewingPolicy: Policy;
    submissionId: string;
}

export interface SubmissionDetailsPost {
    namedInsured: string;
    effectiveDate: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    zip: string;
    intendedProductLineCodes: string[];
}

export interface SubmissionUnderwritingStatus {
    status: string;
    createdAt?: string;
    createdByName?: string;
    statusDisplayName?: string;

    referenceInitials?: string;
    referenceId?: string;
    narrative: string;
}

export interface SubmissionInspectionData {
    contactEmail: string;
    contactName: string;
    contactPhone: string;
    submissionId: string;
}

export default interface NarrativeRequest {
    narrativeText: string;
}

export default interface FetchTokenResponse {
    token: string;
}

export enum PropertyColumn {
    // 'INDEX',
    REMOVE_ICON = 'REMOVE_ICON',
    LOCATION_NAME = 'LOCATION_NAME',
    LOCATION_ADDRESS = 'LOCATION_ADDRESS',
    LOCATION_ADDRESS_2 = 'LOCATION_ADDRESS_2',
    CITY = 'CITY',
    STATE = 'STATE',
    ZIP = 'ZIP',
    COUNTY = 'COUNTY',
    CLASS = 'CLASS',
    CONSTRUCTION_TYPE = 'CONSTRUCTION_TYPE',
    WIRING_TYPE = 'WIRING_TYPE',
    YEAR_OF_CONSTRUCTION = 'YEAR_OF_CONSTRUCTION',
    OCC_PERCENT = 'OCC_PERCENT',
    NUMBER_OF_UNITS = 'NUMBER_OF_UNITS',
    NUMBER_OF_POOLS = 'NUMBER_OF_POOLS',
    NUMBER_OF_BUILDINGS = 'NUMBER_OF_BUILDINGS',
    NUMBER_OF_STORIES = 'NUMBER_OF_STORIES',
    LAST_ROOF_REPLACEMENT_YEAR = 'LAST_ROOF_REPLACEMENT_YEAR',
    ROOF_TYPE = 'ROOF_TYPE',
    ROOF_COVERING = 'ROOF_COVERING',
    SECTION_EIGHT_PERCENT = 'SECTION_EIGHT_PERCENT',
    OWNER_OCCUPIED_PERCENT = 'OWNER_OCCUPIED_PERCENT',
    OWNED_OR_MANAGED = 'OWNED_OR_MANAGED',
    NUMBER_OF_YEARS_OWNED_OR_MANAGED = 'NUMBER_OF_YEARS_OWNED_OR_MANAGED',
    FLOOD_ZONE = 'FLOOD_ZONE',
    HW_SMOKE_DET_ALL_UNITS = 'HW_SMOKE_DET_ALL_UNITS',
    A_S = 'A_S',
    A_S_PERCENT = 'A_S_PERCENT',
    TOTAL_SQUARE_FOOTAGE = 'TOTAL_SQUARE_FOOTAGE',
    BUILDING_VALUE = 'BUILDING_VALUE',
    BI_RENTAL_INCOME_VALUE = 'BI_RENTAL_INCOME_VALUE',
    PERSONAL_PROPERTY_VALUE = 'PERSONAL_PROPERTY_VALUE',
    OTHER_VALUE = 'OTHER_VALUE',
    TOTAL_INSURABLE_VALUE = 'TOTAL_INSURABLE_VALUE',
    INSURANCE_TO_VALUE = 'INSURANCE_TO_VALUE',
    GROSS_SALES = 'GROSS_SALES',
    PLOT_SIZE_ACRES = 'PLOT_SIZE_ACRES',
    MORTGAGEE = 'MORTGAGEE',
    LOSS_PAYEE = 'LOSS_PAYEE',
    ADDITIONAL_NAMED_INSURED = 'ADDITIONAL_NAMED_INSURED',
    ADDITIONAL_INTERESTS = 'ADDITIONAL_INTERESTS',
}
